import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import { actionCreator,
  checkHttpStatus,
  ledgerActionTypes,
  GET_PATIENT,
  GET_MASTERTAGS,
  createSearchUrlForCustomAPI,
  createSearchUrlWithoutPageNumberAndSize,
  GET_CLAIM_SERVICELINE_DETAILS_API,
  GET_LEDGER_DETAILS_API,
  GET_PAYMENT_DETAILS_API,
  GET_MASTERDATABYNAME,
  GET_PATIENT_GUARANTOR_API,
  GET_PATIENT_PAYERS_API,
  jsonApiHeader,
  POST_PAYMENT_DETAILS_API,
  DELETE_CLIENT_PAYMENT_API, 
  UPDATE_CLIENT_PAYMENT_STATUS_API,
  UPDATE_BATCH_CLAIMS_PAYMENT_STATUS,
  UPDATE_BATCH_CLAIMS_OFFICEALLY_STATUS
} from '../constants/ApiConstants';
import { showErrorMessage, showSuccessMessage } from '../constants/ApiConstants';

export const getLedgerDetails = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    // console.log('query_params.............', query_params);
    dispatch(actionCreator(ledgerActionTypes.get_ledgerDetails.REQUEST));
    fetch(`${GET_LEDGER_DETAILS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(ledgerActionTypes.get_ledgerDetails.SUCCESS, response));
      }).catch(function(error) {
        console.log('error getLedgerDetails...', error);
      });
  };
};



export const getLedgerClaimServiceDetails = (claimId) => {
  // let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_ledgerClaimServiceDetails.REQUEST));
    fetch(`${GET_CLAIM_SERVICELINE_DETAILS_API}?claimId=${claimId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(ledgerActionTypes.get_ledgerClaimServiceDetails.SUCCESS, response));
      }).catch(function(error) {
        console.log('error getLedgerDetails...', error);
      });
  };
};

export const getPatient = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=''&isActiveCheckRequired=${searchObj.isActiveCheckRequired}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENT}${query_params}`, {
      method: 'get',
      body: JSON.stringify(),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response.....Patient.............', response);
        dispatch(actionCreator(ledgerActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const getPatientMasterTags = (searchObj) => {
  let query_params = createSearchUrlWithoutPageNumberAndSize(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_patient_master_tags_ForLedger.REQUEST));
    fetch(`${GET_MASTERTAGS}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response-->', response);
        dispatch(actionCreator(ledgerActionTypes.get_patient_master_tags_ForLedger.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response ....', response );
        dispatch(actionCreator(ledgerActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData...', error);
      });
  };
};

export const getPatientPayers = (patientId, key) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_patientPayers.REQUEST));
    fetch(`${GET_PATIENT_PAYERS_API}?PatientID=${patientId}&Key=${key}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(ledgerActionTypes.get_patientPayers.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPatientPayers...', error);
      });
  };
};

export const savePaymentDetails = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.post_paymentDetails.REQUEST));
    fetch(`${POST_PAYMENT_DETAILS_API}`, {
      method: 'post',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(ledgerActionTypes.post_paymentDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error savePaymentDetails...', error);
      });
  };
};

export const getPaymentDetails = (paymentDetailId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_paymentDetails.REQUEST));
    fetch(`${GET_PAYMENT_DETAILS_API}?paymentDetailId=${paymentDetailId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(ledgerActionTypes.get_paymentDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPaymentDetails...', error);
      });
  };
};

export const getPatientGuarantor = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.get_patientGuarantors.REQUEST));
    fetch(`${GET_PATIENT_GUARANTOR_API}?patientId=${patientId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        //console.log('response..................', response);
        dispatch(actionCreator(ledgerActionTypes.get_patientGuarantors.SUCCESS, response));
      })
      .catch(function(error) {

      });
  };
};

export const deleteServiceLinePayment = (paymentDetailId, claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.delete_serviceLine_payment.REQUEST));
    fetch(`${DELETE_CLIENT_PAYMENT_API}/${paymentDetailId}/${claimId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response...........',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);          
        }
        else {
          showErrorMessage(response.message);
        }
        dispatch(getLedgerClaimServiceDetails(claimId));    
        dispatch(actionCreator(ledgerActionTypes.delete_serviceLine_payment.SUCCESS, response));
              
      }).catch(function (error) {
        // console.log(error);
      });
  };

};


export const updateClientPaymentStatus = (claimId, claimPaymentStatusId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.update_clientPaymentStatus.REQUEST));
    fetch(`${UPDATE_CLIENT_PAYMENT_STATUS_API}?claimId=${claimId}&paymentStatusId=${claimPaymentStatusId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_clientPaymentStatus.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_clientPaymentStatus.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_PaymentStatus...', error);
      });
  };
};

export const updateBatchClaimsPaymentStatus = (claimIds, claimPaymentStatusId, searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.update_batch_claims_payment_status.REQUEST));
    fetch(`${UPDATE_BATCH_CLAIMS_PAYMENT_STATUS}?claimIds=${claimIds}&claimPaymentStatusId=${claimPaymentStatusId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_batch_claims_payment_status.SUCCESS, response));
          dispatch(getLedgerDetails(searchObj))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_batch_claims_payment_status.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_payment_status...', error);
      });
  };
};


export const updateBatchClaimsOfficeallyStatus = (claimIds, claimOfficeallyStatusId, searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ledgerActionTypes.update_batch_claims_officeally_status.REQUEST));
    fetch(`${UPDATE_BATCH_CLAIMS_OFFICEALLY_STATUS}?claimIds=${claimIds}&claimOfficeallyStatusId=${claimOfficeallyStatusId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_batch_claims_officeally_status.SUCCESS, response));
          dispatch(getLedgerDetails(searchObj))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(ledgerActionTypes.update_batch_claims_officeally_status.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_Officeally_status...', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/actions/index.js